const slugMaxLength = 125;

export {
  // eslint-disable-next-line import/prefer-default-export
  slugMaxLength,
};
